export default __webpack_public_path__ + "img/square_custom.01df6936503891dcb39b8b57f6c06707.jpg";